module.exports = __webpack_public_path__ + "static/Humanity-04ba4636c5f4201b934adcacf99aa385.png";